export default __webpack_public_path__ + "static/media/repair.c0000831.svg";